import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M5.7 5.7l12.6 12.6","key":"svg-1"}]]

const IconBan = createReactComponent('outline', 'ban', 'Ban', __iconNode);

export default IconBan;